import ReactDOM from 'react-dom/client';
import { HeroUIProvider } from '@heroui/react';
import './index.css';
import './assets/styles/main.css';
import { Provider } from 'react-redux';
import store from './core/store';
import { ErrorBoundary } from 'react-error-boundary';
import App from './user-management/App';
import { BrowserRouter as Router } from 'react-router-dom';
import SharedModal from './shared/components/modal/SharedModal';
import ModalManager from './shared/components/modal/ModalManager';
import { sendErrorFeedback } from './utils/helpers';
import { ErrorInfo, useEffect } from 'react';
import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';
import { SessionSyncProvider } from './SessionSyncProvider';
import AlertProvider from './shared/components/alert/AlertProvider';
import GlobalAlertService from './shared/services/GlobalAlertService';
import setupApplicationInsights from './services/application-insights/setupAppInsights';
import { LogLevel, trackExceptionWithContext } from './services/application-insights/appInsights';

ModuleRegistry.registerModules([AllEnterpriseModule]);

// AG-GRID LICENSE
LicenseManager.setLicenseKey(
	'Using_this_{AG_Grid}_Enterprise_key_{AG-096111}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{MARITIME_STRATEGIES_INTERNATIONAL_LIMITED}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Argo}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Argo}_need_to_be_licensed___{Argo}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{12_February_2027}____[v3]_[01]_MTgwMjM5MDQwMDAwMA==03f85cbf7373be39f97a12f087979db0',
);

const handleError = (error: Error, info: ErrorInfo) => {
	// Add Application Insights tracking
	trackExceptionWithContext(error, {
		component: 'ErrorBoundary',
		action: 'react-error-boundary-catch',
		severity: LogLevel.Critical,
		additionalData: { componentStack: info.componentStack },
	});
	ModalManager.show({
		size: 'lg',
		header: 'Contact MSI - Unexpected Error',
		message: error?.message || 'An error occurred',
		messageDetails: `${error?.stack}\n\nComponent Stack:\n${info.componentStack}`,
		onCancel: () => {
			window.location.reload();
		},
		onConfirm: () => {
			sendErrorFeedback(error);
		},
		cancelButtonText: 'Refresh',
		actionButtonText: 'Send to MSI',
	});
};

// Main App Component with Human Verification
const MainApp = () => {
	// Register service worker when the app loads
	useEffect(() => {
		setupApplicationInsights();
	}, []);

	return (
		<HeroUIProvider locale={'en-GB'}>
			<ErrorBoundary onError={handleError} fallbackRender={() => null}>
				<SessionSyncProvider />
				<Provider store={store}>
					<AlertProvider>
						<GlobalAlertService />
						<Router>
							<App />
						</Router>
					</AlertProvider>
				</Provider>
			</ErrorBoundary>
			<SharedModal />
		</HeroUIProvider>
	);
};

ReactDOM.createRoot(document.getElementById('root')!).render(
	// <React.StrictMode>
	<MainApp />,
	// </React.StrictMode>,
);
